import React from 'react';

const TourCard = ({ title, imageSrc, content, toursCount, link }) => (
  <div className="col-12 col-md-4 mb-4">
    <div className="elementor-widget-wrap elementor-element-populated text-center h-100">
      <div
        className="elementor-element elementor-widget elementor-widget-gva_ba_banner h-100"
        data-element_type="widget"
        data-widget_type="gva_ba_banner.default"
      >
        <div className="elementor-widget-container h-100 ">
          <div className="gva-element-gva_ba_banner gva-element h-100 d-flex flex-column justify-content-between ">
            <div className="gsc-booking-banner text-left style-3 bg-or borderr">
              <div className="listings-banner-content bg-or">
                <div className="banner-image bg-or">
                  <img decoding="async" src={imageSrc} alt={title} />
                </div>
                <div className="banner-content bg-or">
                  <h3 className="title">{title}</h3>
                </div>
                  <p className="title bg-or text-white">{content}</p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const HomeOurfleet = () => {
 const tours = [
  {
    title: 'Maruti Celerio',
    content: 'Ideal for short trips and city rides with great mileage and comfort.',
    imageSrc: '/images/booking/1.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Maruti WagonR',
    content: 'Spacious and reliable, perfect for everyday city commuting.',
    imageSrc: '/images/booking/2.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'BMW',
    content: 'Luxury sedan offering premium comfort and stylish travel.',
    imageSrc: '/images/booking/3.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Mercedes C Class',
    content: 'Elegant design and smooth performance for business class travel.',
    imageSrc: '/images/booking/4.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Toyota Innova Crysta',
    content: 'Spacious and powerful MPV for long trips and family outings.',
    imageSrc: '/images/booking/5.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Mercedes E Class',
    content: 'Executive-class comfort and technology for luxury travel.',
    imageSrc: '/images/booking/6.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Toyota Fortuner',
    content: 'Rugged SUV with bold styling for off-road and highway rides.',
    imageSrc: '/images/booking/7.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Mercedes GLS',
    content: 'Top-tier luxury SUV offering unmatched comfort and space.',
    imageSrc: '/images/booking/8.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Mercedes S Class',
    content: 'The epitome of luxury and elegance for premium experiences.',
    imageSrc: '/images/booking/9.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Toyota Innova',
    content: 'Trusted and comfortable choice for outstation group travel.',
    imageSrc: '/images/booking/10.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Mahindra Marrazzo',
    content: 'Spacious MPV perfect for family trips and group tours.',
    imageSrc: '/images/booking/11.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Toyota Etios',
    content: 'Reliable sedan with good mileage and passenger comfort.',
    imageSrc: '/images/booking/12.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Maruti Dzire',
    content: 'Compact, stylish, and budget-friendly for city drives.',
    imageSrc: '/images/booking/13.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Hyundai Xcent',
    content: 'Sleek sedan ideal for personal and corporate travel.',
    imageSrc: '/images/booking/14.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Maruti Ciaz',
    content: 'Spacious sedan offering elegance and a smooth drive.',
    imageSrc: '/images/booking/15.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Toyota Camry',
    content: 'Premium hybrid sedan combining power and efficiency.',
    imageSrc: '/images/booking/16.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Tempo traveller',
    content: 'Ideal for large groups and comfortable long-distance travel.',
    imageSrc: '/images/booking/17.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Mahindra Xylo',
    content: 'Spacious SUV for mid-size groups and outstation trips.',
    imageSrc: '/images/booking/18.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Maruti Ertiga',
    content: 'Versatile MPV for both families and corporate use.',
    imageSrc: '/images/booking/19.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Honda Amaze',
    content: 'Comfortable compact sedan for budget-friendly travel.',
    imageSrc: '/images/booking/20.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Honda City',
    content: 'Stylish and smooth sedan great for city and highway rides.',
    imageSrc: '/images/booking/21.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Toyota Corolla',
    content: 'Reliable and comfortable sedan for daily and long trips.',
    imageSrc: '/images/booking/22.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Bus 30 Seater',
    content: 'Perfect for medium-sized groups and school or team outings.',
    imageSrc: '/images/booking/23.jpg',
    toursCount: 3,
    link: '#'
  },
  {
    title: 'Bus 35 Seater',
    content: 'Spacious bus ideal for events, tours, and long-distance travel.',
    imageSrc: '/images/booking/24.jpg',
    toursCount: 3,
    link: '#'
  }
];

  return (
    <>
    
 <div className='section-title text-center'>
<span className='section-title__tagline'>Our fleet</span>
<div className='section-title__title'>Our Fleets Services </div>
 </div>
     
      <section className="elementor-section row-top">
        <div className="container">
          <div className="row mb-5">
           
          </div>
          <div className="row">
            {tours.map((tour, index) => (
              <TourCard
                key={index}
                title={tour.title}
                // content={tour.content}
                imageSrc={tour.imageSrc}
                toursCount={tour.toursCount}
                link={tour.link}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeOurfleet;
